import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getEntries, getSearch, getFilters, getSettings } from '../../common/services/selectors';
import AToZNavItem from './atozNavItem';

function AtoZNav({ search, filters, settings }) {
    let alphabet = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    let clsName = search.startWith ? 'a-z-nav__link  a-z-nav__link--' : 'a-z-nav__link  a-z-nav__link--selected';
    return (
    <div className="a-z">
        <div className="row">
            <a className={clsName} href="#">ALL</a>
            { Array.isArray(alphabet) && alphabet.map((item) => 
            {
                return <AToZNavItem key={item} item={item} search={search} />
            })}
        </div>
    </div>
	);
}
AtoZNav.propTypes = {
    entries: PropTypes.object,
};

const mapStateToProps = state => ({ entries: getEntries(state), search: getSearch(state), filters: getFilters(state), settings: getSettings(state) });

export default connect(mapStateToProps)(AtoZNav);